export default "/static/explore/52637a98b6af851089caccbad8aa8eb115d3d065/_next/static/images/logo-square-win8-275a043cc1f684123da98a0554ffd1b7.png";